import Animations from './modules/Animations'
import DragToScroll from './modules/DragToScroll'
import Menu from './modules/Menu'
import Modal from './modules/Modal'
import FloatingButton from './modules/FloatingButton'
// import PinnedBox from './modules/PinnedBox'
import Sliders from './modules/Sliders'
// Changed SmartPOS video section with new static image layout
// import SmartPos from './modules/SmartPos'
import Tooltips from './modules/Tooltips'

export default class Main {
  constructor() {
    this.init()
  }

  init() {
    DragToScroll.init()
    Menu.init()
    Modal.init()
    // PinnedBox.init()
    Sliders.init()
    Tooltips.init()
    FloatingButton.init()

    // run once when page loads
    window.addEventListener('DOMContentLoaded', () => {
      // SmartPos.init()
      Animations.init()
    })
  }
}

const main = new Main()
